import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const widgetTouchAtom = atom({
    default: false,
    key: ATOM_KEY.WIDGET_TOUCH,
});

export const useWidgetTouchState = () => useRecoilState(widgetTouchAtom);
export const useSetWidgetTouchState = () => useSetRecoilState(widgetTouchAtom);
export const useWidgetTouchValue = () => useRecoilValue(widgetTouchAtom);
